import { Col, Form, Input, InputRef, Modal, Row } from "antd";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import Discount from "./Discount";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { checkAdmin } from "../../../../api/auth";
import Title from "../../../UI/Title/Title";
import { message } from "antd";
type PropsType = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const CheckAdmin = ({ open, setOpen }: PropsType) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [t] = useTranslation("common");
  const [openDiscount, setOpenDiscount] = useState(false);
  const nameInput = useRef<InputRef>(null);
  const { mutateAsync: checkAminMutation } = useMutation(
    "checkAdmin",
    (obj: { userName: string; password: string }) => checkAdmin(obj)
  );

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        nameInput.current?.focus();
      }, 0);
    }
  }, [open]);

  const handleSubmit = () => {
    checkAminMutation({
      userName: form.getFieldValue("username"),
      password: form.getFieldValue("password"),
    })
      .then(() => {
        setOpenDiscount(true);
        setOpen(false);
        form.resetFields();
      })
      .catch((err) => {
        message.error("Wrong credentials");
      });
  };
  const [capsLockOn, setCapsLockOn] = useState(false);

  const handleKeyPress = (e: any) => {
    // const isCapsLockOn = e.getModifierState("CapsLock");
    const isCapsLockOn = false;
    setCapsLockOn(isCapsLockOn);
  };
  useEffect(() => {
    // Add event listener when component mounts
    window.addEventListener("keydown", handleKeyPress);

    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };
  return (
    <>
      {contextHolder}
      <Modal
        centered
        open={open}
        closable={false}
        maskClosable={false}
        width={400}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          htmlType: "submit",
          form: "formdiscount",
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={`${t("confirm")}`}
        onCancel={() => {
          handleCancel();
          document.body.classList.remove("body-scroll-lock");
        }}
        cancelText={t('cancel')}
      >
        <Form
          form={form}
          id="formdiscount"
          layout="vertical"
          initialValues={[]}
          onFinish={handleSubmit}
        >
          <Row>
            <Col offset={1} span={22}>
              <Title title={`${t("confirm-credentials")}`} />
            </Col>

            <Col
              offset={1}
              span={23}
              className="modaltitleEdit"
              style={{ marginBottom: "20px" }}
            >
              {t("confirm-credentials-to-add-discount")}
            </Col>

            <Col offset={1} span={16}>
              <Form.Item
                name="username"
                label={`${t("name")}`}
                rules={[
                  {
                    required: true,
                    message: "Missing username *",
                  },
                ]}
              >
                <Input
                  placeholder={`${t("enter-text")}`}
                  autoComplete="off"
                  ref={nameInput}
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={`${t("password")}`}
                rules={[
                  {
                    required: true,
                    message: "Missing password *",
                  },
                ]}
              >
                <Input.Password
                  placeholder={`${t("enter-text")}`}
                  autoComplete="off"
                  onKeyDown={handleKeyPress}
                />
              </Form.Item>

              {capsLockOn ? (
                <div style={{ color: "red", marginTop: "5px" }}>
                  Caps Lock is on
                </div>
              ) : (
                <div
                  style={{
                    color: "#0048C5",
                    marginTop: "5px",
                    visibility: "hidden",
                  }}
                >
                  Caps Lock is off
                </div>
              )}
            </Col>
          </Row>
        </Form>
      </Modal>
      <Discount open={openDiscount} setOpen={setOpenDiscount} />
    </>
  );
};

export default CheckAdmin;
